import { List, Map } from 'immutable';
import type { Reducer } from 'redux';
import ErrorRecord from '~/data/ErrorRecord';
import type { EditInviteRequestActions } from './types/actions.types';
import Constants from './constants';
import EditInviteRequestRecord from './data/EditInviteRequestRecord';
import EditInviteRequestFormRecord from './data/EditInviteRequestFormRecord';

function getInitialState() {
  return new EditInviteRequestRecord();
}

const defaultState = getInitialState();

const reducer: Reducer<EditInviteRequestRecord, EditInviteRequestActions> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case Constants.GET_INVITE_REQUEST_DETAILS_REQUEST:
      return state.merge({
        isLoading: true,
        countries: List(),
        languages: List(),
        defaultLanguage: Map(),
        businessPartners: List(),
        formData: new EditInviteRequestFormRecord(),
        errors: undefined,
      });

    case Constants.GET_INVITE_REQUEST_DETAILS_REQUEST_SUCCESS:
      return new EditInviteRequestRecord({
        isLoading: false,
        countries: action.response.countries,
        languages: action.response.languages,
        defaultLanguage: Map(action.response.defaultLanguage),
        businessPartners: action.response.businessPartners,
        formData: new EditInviteRequestFormRecord(action.response.inviteRequestDetails),
      });

    case Constants.GET_INVITE_REQUEST_DETAILS_REQUEST_ERROR:
      return state.merge({
        isLoading: false,
        errors: List(action.errors.map((error) => new ErrorRecord(error))),
      });

    case Constants.SAVE_AND_APPROVE_INVITE_REQUEST:
    case Constants.SAVE_AND_REJECT_INVITE_REQUEST:
    case Constants.SAVE_INVITE_REQUEST_DETAILS_REQUEST:
      return state.merge({
        isSaving: true,
        isSaved: false,
        errors: undefined,
      });

    case Constants.SAVE_AND_APPROVE_INVITE_REQUEST_SUCCESS:
    case Constants.SAVE_AND_REJECT_INVITE_REQUEST_SUCCESS:
    case Constants.SAVE_INVITE_REQUEST_DETAILS_REQUEST_SUCCESS:
      return state.merge({
        isSaving: false,
        isSaved: true,
      });

    case Constants.SAVE_AND_APPROVE_INVITE_REQUEST_ERROR:
    case Constants.SAVE_AND_REJECT_INVITE_REQUEST_ERROR:
    case Constants.SAVE_INVITE_REQUEST_DETAILS_REQUEST_ERROR:
      return state.merge({
        isSaving: false,
        isSaved: false,
        errors: List(action.errors.map((error) => new ErrorRecord(error))),
      });

    default:
      return state;
  }
};

export default reducer;
